import type { AxiosError } from 'axios'

export type ApiError = AxiosError<{ message?: string }>

export function getApiErrorMessage(error) {
  if (error.response && error.response.data && error.response.data.message) {
    return error.response.data.message
  }
  return error.message
}
